import React, { Component } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import NgGameRPGArenaUi from './ui';
import NgGameRPGChar from './char';
import NgGameRPGSnowman from './snowman';
import NgGameRPGEffects from './effects';
import { NgGameRPGArenaLive } from './lives/lives';
import NgGameRPGEMoveList from './moveList';
import NgGameRPGEThinkTime from './thinkTime';
import NgGameRPGEBuffs from './buffs';
// import { SnowFall } from '../../../ngstat/snowfall'
import { GoSnow } from '../../snowfall3d';
import { gsap } from 'gsap';
import './style.css';

export default class NgGameRPGArena extends Component {

    state = {
        phase: 'startscreen',
        gameStarted: false,
        enemy: null
    }

    uiRef = React.createRef();
    uiChar = React.createRef();
    refSnowMan = React.createRef();
    refEffects = React.createRef();
    refEffectsBack = React.createRef();
    refMoveList = React.createRef();
    refThinkTime = React.createRef();
    refBuffs = React.createRef();

    get getUiRef() {
        return !!this.uiRef && this.uiRef.current;
    }
    get getThinkTimeRef() {
        return !!this.refThinkTime && this.refThinkTime.current;
    }

    startGame = (props) => {
        this.setState({ gameStarted: true })
    }

    stopGame = (props) => {
        this.setState({ gameStarted: false })
    }

    addEnemy = (enemy) => {
        this.setState({ enemy })
    }

    componentDidMount = () => {
        this.cameraOn(50);
    }

    addCharAnimation = (props) => {
        this.uiChar && this.uiChar.current && this.uiChar.current.addAnimation(props);
    }

    setSnowManAnimation = (props) => {
        this.refSnowMan && this.refSnowMan.current && this.refSnowMan.current.addAnimation(props);
    }

    cameraOnPerson = ({ person = 1 }) => {

        const { settings = {} } = this.props;

        if (settings.disableBackMove) return null;

        if (person === 1) {
            this.cameraOn(20);
        }
        if (person === 2) {
            this.cameraOn(80);
        }
    }

    cameraOn = (percent) => {

        const { height } = this.props;
        const koef = 1500 / height;

        const widthReal = 4119;
        const widthFull = widthReal / koef;

        const widthScreen = height * 1.72;
        const perc100 = widthFull - widthScreen;

        // console.log(`ПЕРЕВОЖУ КАМЕРУ ${percent}`)

        gsap.to('.ngg_arena_main_backfon img', {
            translateX: `-${perc100 * (percent / 100)}px`,
            duration: 2
        }
        )


        const frontHeight = height * 0.21;
        const koef2 = 300 / frontHeight;
        // 3167 * 300 front
        const frontWidth = 3167 / koef2;
        const perc100_2 = frontWidth - widthScreen;

        gsap.to('.ngg_arena_main_frontfon img', {
            translateX: `-${perc100_2 * ((100 - percent) / 100)}px`,
            duration: 2
        }
        )

    }

    // может быть отослано от снеговика или чара
    addEffectAnimation = (props) => {
        const { buff, action } = props;
        if (!action && (!buff || !buff.type)) return;

        if (action === 'gigo_strike') {
            const { y } = props;

            const { height } = this.props;
            const chartLeft = height * 0.54;
            const charWidth = height * 0.42 * (144 / 200);

            this.refEffects.current.deadSnowMan({
                x: chartLeft + charWidth / 2, y, xForce: 0, yForce: -7, radius: 11
            })
        }

        if (buff && buff.type)
            switch (buff.type) {
                case 'sn_spices': {
                    const { spicesAt } = buff;
                    if (!spicesAt || !spicesAt.length) return;
                    const { height } = this.props;
                    const width = height * 1.72;

                    const snowmanTop = height * 0.88;
                    const snowmanHeight = height * 0.42;

                    const snowmanLeft = height * 1.121;
                    const snowmanWidth = snowmanHeight * 0.28;

                    let correctY = 0;
                    const point = 1;

                    const animations = [];

                    spicesAt.forEach((point) => {
                        if (point === 1) correctY = height * 0.15;
                        if (point === 2) correctY = height * 0.25;
                        if (point === 3) correctY = height * 0.34;
                        animations.push(
                            {
                                x: snowmanLeft - (snowmanWidth / 2), y: snowmanTop - snowmanHeight + correctY, type: 'spices'
                            }
                        )
                    })

                    this.refEffectsBack.current.addAnimation(animations);
                    break;
                }
                default: { }
            }
    }

    // тут еще должна быть выборка какая-то по идее, как именно ударил
    hittedSnowMan = (props) => {

        const { point, type } = props;

        const { height } = this.props;
        const snowmanTop = height * 0.88;
        const snowmanHeight = height * 0.42;

        const snowmanLeft = height * 1.121;

        let correctY = 0;
        if (point === 1) correctY = height * 0.1;
        if (point === 2) correctY = height * 0.2;
        if (point === 3) correctY = height * 0.3;

        if (!type) {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 10, yForce: -1
            })
        }
        if (type === 'noDamage') {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 3, yForce: -1
            })
        }

        if (type === 'armorHitted') {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 5, yForce: 1, radius: 11, color: 'blue'
            })
            this.setSnowManAnimation({
                point,
                event: props.event,
                type: 'armorHitted',
            })
        }
        if (type === 'armorDestroyed') {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 15, yForce: 2, radius: 11, color: 'darkblue'
            })
            this.setSnowManAnimation({
                point,
                event: props.event,
                type: 'armorDestroyed',
            })
        }

        if (type === 'deflectHitted') {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 5, yForce: 1, color: 'blue'
            })
            this.setSnowManAnimation({
                point,
                event: props.event,
                type: 'deflectHitted',
            })
        }
        if (type === 'deflectDestroyed') {
            this.refEffects.current.hitOnSnowMan({
                x: snowmanLeft, y: snowmanTop - snowmanHeight + correctY, xForce: 15, yForce: 2, color: 'darkblue'
            })
            this.setSnowManAnimation({
                point,
                event: props.event,
                type: 'deflectDestroyed',
            })
        }
        if (type === 'dead') {
            this.refEffects.current.deadSnowMan({
                x: snowmanLeft, y: snowmanTop - (snowmanHeight / 2), xForce: 0, yForce: -12, radius: 7
            })
            this.refEffects.current.deadSnowMan({
                x: snowmanLeft, y: snowmanTop - (snowmanHeight / 2), xForce: 0, yForce: -7, radius: 11
            })
        }

        this.setSnowManAnimation({
            type: 'hitted',
            point
        })

    }

    simpleClickTest = () => {
    }

    // поменять жизни в полосках жизни
    changeLive = ({ Pers, index }) => {
        const { lives, innerLives } = Pers;
        const firstContainer = (index === 1) ? '.ngg_arena_lives_container_left' : '.ngg_arena_lives_container_right'
        gsap.to(`${firstContainer} .ngg_arena_lives_container_hp`, {
            width: `${(lives / innerLives) * 100}%`,
            duration: 0.8,
            ease: "power1.out"
        }
        )

        gsap.to(`${firstContainer} .ngg_arena_lives_container_hpmin`, {
            width: `${(lives / innerLives) * 100}%`,
            duration: 0.8,
            ease: "power1.out"
        }
        )

    }

    changePers1Buffs = ({ person1Buffs }) => {
        this.refEffectsBack.current && this.refEffectsBack.current.setPersonBuffs({ person1Buffs });
    }

    changePers2Buffs = (props) => {
        this.refBuffs.current && this.refBuffs.current.changePers2Buffs && this.refBuffs.current.changePers2Buffs(props);
    }

    // установить корректо Move блоки
    setBlocks = ({ NowBlock, nowBlockMoveNumber, nowMoveNumber } = {}) => {
        this.refMoveList.current.setBlocks({ NowBlock, nowBlockMoveNumber, nowMoveNumber })
    }
    setMoveListExtras = (props) => {
        this.refMoveList.current.setExtras(props)
    }

    render() {

        const { enemy } = this.state;
        const { height } = this.props;
        const width = height * 1.72;
        const charHeight = height * 0.42;

        const chartTop = height * 0.88;
        const chartLeft = height * 0.54;

        // 4119 * 1500 back
        // 3167 * 300 front

        const backFon = 'back1';
        const fronFon = 'forw1';

        const frontHeight = height * 0.21;

        const snowmanHeight = height * 0.42;

        const snowmanTop = height * 0.88;
        const snowmanLeft = height * 0.97;

        const { settings = {} } = this.props;
        const { gameStarted } = this.state;

        // if (!gameStarted) {
        //     return <div className='ngg_arena_main' style={{ height, width }}>
        //         <NgGameRPGArenaUi ref={this.uiRef} onStartClick={this.onStartClick} onUiClick={this.onUiClick} arena={{ width, height }} />
        //         <div className='ngg_arena_main_backfon'>
        //             <img src={`/../images/ver2/snowman/fon/${backFon}.jpg`} />
        //         </div>
        //     </div>
        // }


        return <div className='ngg_arena_main' style={{ height, width }}>
            <NgGameRPGArenaUi ref={this.uiRef} onStartClick={this.onStartClick} onUiClick={this.onUiClick} arena={{ width, height }} />
            <div className='ngg_arena_main_backfon'>
                <img src={`/../images/ver2/snowman/fon/${backFon}.jpg`} />
            </div>


                {!settings.noSnow && <GoSnow settings={settings} width={width} height={height} zIndex={1} />}
                <NgGameRPGChar settings={settings} ref={this.uiChar} arena={{ width, height }} height={charHeight} top={chartTop} left={chartLeft} zIndex={2} />
                <NgGameRPGEffects settings={settings} noPartic ref={this.refEffectsBack} width={width} height={height} zIndex={1} />
                {!!enemy && <NgGameRPGSnowman settings={settings} ref={this.refSnowMan} arena={{ width, height }} snowman={enemy} addEffectAnimation={this.addEffectAnimation} height={snowmanHeight} top={snowmanTop} left={snowmanLeft} zIndex={2} />}
                <NgGameRPGEffects settings={settings} ref={this.refEffects} width={width} height={height} zIndex={3} />
                <div className='ngg_arena_main_frontfon' style={{ height: frontHeight }}>
                    <img src={`/../images/ver2/snowman/fon/${fronFon}.png`} onClick={this.simpleClickTest} />
                </div>

                <NgGameRPGArenaLive arena={{ width, height }} isLeft zIndex={5} />
                <NgGameRPGArenaLive arena={{ width, height }} zIndex={5} />
                <NgGameRPGEBuffs ref={this.refBuffs} arena={{ width, height }} zIndex={5} />

                <NgGameRPGEMoveList ref={this.refMoveList} arena={{ width, height }} zIndex={6} />
            <NgGameRPGEThinkTime ref={this.refThinkTime} arena={{ width, height }} zIndex={6} sendThinkTimePercent={this.sendThinkTimePercent} />
        </div>
    }

}